import { render, staticRenderFns } from "./SuffixInput.vue?vue&type=template&id=48b533ef&scoped=true"
import script from "./SuffixInput.vue?vue&type=script&lang=js"
export * from "./SuffixInput.vue?vue&type=script&lang=js"
import style0 from "./SuffixInput.vue?vue&type=style&index=0&id=48b533ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b533ef",
  null
  
)

export default component.exports